import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { darken } from '@material-ui/core/styles/colorManipulator';
import PrimaryCardWithCollection from 'Components/ComponentLibrary/Molecules/PrimaryCardWithCollection';
import {
  useSummarySidebarContentContext,
} from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/DetailPicker/Details/Context';
import fr from 'facet-rest';

const styles = theme => ({
  root: {
    padding: theme.spacing(2),
  },
  addButton: {
    marginTop: theme.spacing(1),
    justifyContent: 'left',
    width: '100%',
  },
  title: {
    paddingBottom: theme.spacing(2),
  },
  expenseSectionContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  expenseSectionValue: {
    flexBasis: '25%',
    flexShrink: 0,
  },
  expenseDescriptionTitle: {
    fontWeight: theme.typography.fontWeightBold,
  },
  lineItem: {
    width: '100%',
    padding: theme.spacing(0.5, 0),
  },
  selectableLineItem: {
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: darken(
        theme.palette.facet.accentBlue20,
        theme.palette.action.hoverOpacity,
      ),
    },
  },
});

const ExpenseSection = ({
  className,
  classes,
  resource,
}) => {
  const {
    handleAddExpense,
    handleModifyExpense,
  } = useSummarySidebarContentContext();

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <PrimaryCardWithCollection
        title={'Itemized'}
        resource={resource}
        onAdd={resource.relationship(fr.relationships.addExpense.name) ? () => handleAddExpense(resource) : null}
        onEdit={(res) => handleModifyExpense(res)}
        itemCollection={resource.attr('expenses')}
        getItemPrimaryText={(expenseItem) => expenseItem.attr('label')}
        getItemSecondaryText={(expenseItem) => {
          return (
            <>
              {expenseItem.attr('descriptionTimePeriod')}
              <br />
              {expenseItem.attr('descriptionGroupCategory')}
            </>
          );
        }}
        emptyListAlertTitle={'No Expenses'}
      />
    </Box>
  );
};

ExpenseSection.defaultProps = {
  className: '',
};

ExpenseSection.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
};

export default withStyles(styles)(ExpenseSection);
